import React from 'react'

const NoMatch = (props) => (
    <div className="container">
        <h2 className="page-title">Page not found</h2>
        <div className="contact-us-container">
            We're sorry that page was not found.
        </div>
    </div>
)

export default NoMatch